import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { Platform } from 'ionic-angular';

/*
  Generated class for the InAppBrowserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class InAppBrowserProvider {

    constructor(public inAppBrowser: InAppBrowser, public platform: Platform) {

    }

    openWebpage(url: string) {

        const options: InAppBrowserOptions = {
            zoom: 'no',
            location: 'yes'
        };

        const browser = this.inAppBrowser.create(url, '_blank', options);
        browser.show();
    }

}



// WEBPACK FOOTER //
// ./src/providers/in-app-browser/in-app-browser.ts